<div class="loading-image-container">
    <img class="center-img" [src]="'assets/icons/coupon-img.svg' | deployUrl" [alt]="'Coupon Decorative'" />
</div>
<div class="info-modal-warning" *transloco="let t">
    <p class="main-text">{{t('modals.cart.coupon_conflict_1')}}</p>
    <p class="details-text">{{t('modals.cart.coupon_conflict_2')}}</p>
    <p class="coupon-name">{{couponWarning()?.bestCouponCode}}</p>
    <hr class="divider" />
</div>